import { render, staticRenderFns } from "./cardType-detail.vue?vue&type=template&id=08d2e5bf"
import script from "./cardType-detail.vue?vue&type=script&lang=js"
export * from "./cardType-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports